export const rgba = (r: number, g: number, b: number, a: number) => `rgba(${r},${g},${b},${a})`
